import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-use-form-state';
import { TeamValidator } from '@shoflo/polymer/validators/TeamValidator/TeamValidator';
import { Input, Form, FormGroup } from 'reactstrap';

import { Button } from '@shoflo/polymer/components/Button/Button';
import StyledFormLabel from 'components/form/StyledFormLabel';

const CreateTeamForm = ({ onSubmit, onCancel }) => {
  const [formState, { text }] = useFormState({
    title: '',
  });

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({
          title: formState.values.title,
          industry: 'Corporate',
        });
      }}
    >
      <FormGroup>
        <StyledFormLabel id="elementSetTitleLabel" htmlFor="elementSetTitle">
          Team Name
        </StyledFormLabel>
        <Input
          id="elementSetTitle"
          aria-labelledby="elementSetTitleLabel"
          placeholder="Team Name"
          {...text({
            name: 'title',
            validate: TeamValidator.title,
            touchOnChange: true,
          })}
          invalid={formState.touched.title && !formState.validity.title}
          required
        />
      </FormGroup>

      <div className="float-end form-footer">
        <Button color="primary" disabled={!formState.validity.title}>
          Create
        </Button>{' '}
        <Button
          color="secondary"
          variant="outlined"
          onClick={(e) => {
            e.preventDefault();
            onCancel();
          }}
        >
          Cancel
        </Button>
      </div>
    </Form>
  );
};

CreateTeamForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default CreateTeamForm;
